import { User } from '@modules/auth/hooks/types'

import { getEventDefaultInfo } from '../utils'

export const preparePendoMarkAsViewedEvent = ({
  eventType,
  savedSearchId,
  user,
}: {
  eventType: 'hover' | 'mark_as_read' | 'mark_all_as_read'
  savedSearchId: number
  user?: User | null
}) => {
  return {
    ...getEventDefaultInfo(user),
    location: 'Search page',
    saved_search_id: savedSearchId,
    eventType,
  }
}
